<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-dialog v-model="Dialog.isShow" width="550">
    <v-card>
      <v-card-title class="text-h6 orange lighten-2 font-weight-bold pa-3">
        <v-icon class="mt-1 mr-3" large dark>mdi-alert-circle-outline</v-icon>
        <div style="color: white">訊息</div>
      </v-card-title>

      <v-card-text class="text-h5 pa-4 text-start">
        {{ Dialog.msg }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="Cancel()"> 取消 </v-btn>
        <v-btn color="orange darken-2" text @click="Agree()"> 確定 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      timer: null,
    };
  },
  computed: {
    ...mapState({
      Dialog: "Dialog",
    }),
  },
  methods: {
    Cancel() {
      let dialog = [false, null, false];
      this.$store.dispatch("SetDialog", dialog);
    },
    Agree() {
      let dialog = [false, null, true];
      this.$store.dispatch("SetDialog", dialog);
    },
  },
};
</script>
